// extracted by mini-css-extract-plugin
export default {"model":"styles_model__TlMWc","divContainer":"styles_divContainer__qiosb","divQR":"styles_divQR__8uZ7b"};